import {gql} from '@apollo/client';

export const GET_ALL_ACADEMY_CODES = gql`
  query GetAllCoupons($filter: CouponFilter) {
    getAllCoupons(filter: $filter) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithCoupons {
        message
        data {
          id
          coupon
          type
          value
          couponUsageLimit
          startDate
          endDate
          totalRedemption
          isEnabled
          promoCodeType
          ownerType
          ownerId
          owner {
            id
            firstName
            lastName
            email
          }
        }
        pagination {
          total
        }
      }
    }
  }
`;

export const CREATE_ACADEMY_CODE = gql`
  mutation CreateCoupon($input: CreateCouponInput!) {
    createCoupon(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithCoupon {
        message
      }
    }
  }
`;

export const DELETE_COUPON = gql`
  mutation DeleteCoupon($deleteCouponId: ID!) {
    deleteCoupon(id: $deleteCouponId) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithCoupon {
        message
      }
    }
  }
`;

export const GET_SINGLE_ACADEMY_CODE = gql`
  query GetCouponById($getCouponByIdId: ID!) {
    getCouponById(id: $getCouponByIdId) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithCoupon {
        data {
          isEnabled
          startDate
          endDate
          totalRedemption
          fixedDiscountCoupon {
            currency
            amount
          }
          coupon
          type
          value
          couponUsageLimit
          promoCodeType
          ownerType
          ownerId
          owner {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;

export const UPDATE_ACADEMY_CODE = gql`
  mutation UpdateCoupon($input: UpdateCouponInput!) {
    updateCoupon(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithCoupon {
        message
      }
    }
  }
`;

export const GET_ALL_ACADEMY_CODE_STATS = gql`
  query GetCouponStats {
    getCouponStats {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithCouponStats {
        data {
          expiredPromoCodes
          totalUsedPromoCodes
          activePromoCodes
        }
      }
    }
  }
`;

export const GET_PROMO_CODE_USERS = gql`
  query GetCouponUsers($filter: CouponUserFilter) {
    getCouponUsers(filter: $filter) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithCouponUsers {
        data {
          email
          name
          phoneNumber
          amount
          discountAmount
          createdAt
        }
      }
    }
  }
`;

/**
 * Live validation for the promo code typed on a manual DABA_ACADEMY wallet
 * transaction. The resolved owner is the only link between a course sale and
 * the person who earns commission on it, so it must be shown before submit.
 */
export const VALIDATE_COUPON = gql`
  query GetCoupon($coupon: String!) {
    getCoupon(coupon: $coupon) {
      ... on ResponseWithCoupon {
        message
        data {
          id
          coupon
          type
          value
          ownerType
          owner {
            id
            firstName
            lastName
            email
          }
        }
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;

export const couponOwnerTypes = [
  {label: 'Platform (plain discount)', value: 'PLATFORM'},
  {label: 'Sales Agent (internal)', value: 'AGENT'},
  {label: 'Referral Partner (external)', value: 'REFERRAL_PARTNER'},
];
